module.exports = __webpack_public_path__ + "img/NL.0959a8c5.svg";